import styled, { css } from 'styled-components';
import { CheckIcon } from '../../icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CheckboxContainer = styled.div.withConfig({
  displayName: "Checkbox__CheckboxContainer",
  componentId: "lztpq3-0"
})(["user-select:none;align-items:flex-start;display:flex;min-height:32px;position:relative;"]);
const CheckboxLabel = styled.label.withConfig({
  displayName: "Checkbox__CheckboxLabel",
  componentId: "lztpq3-1"
})(["cursor:pointer;display:block;max-width:100%;"]);
const CheckboxWrapper = styled.span.withConfig({
  displayName: "Checkbox__CheckboxWrapper",
  componentId: "lztpq3-2"
})(["display:flex;align-items:flex-start;"]);
const HiddenInput = styled.input.withConfig({
  displayName: "Checkbox__HiddenInput",
  componentId: "lztpq3-3"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["position:absolute !important;top:0 !important;width:1px !important;height:1px !important;margin:-1px !important;padding:", " !important;overflow:hidden !important;clip:rect(0,0,0,0) !important;border:0 !important;"], theme.space['0']);
});
const CheckboxIndicator = styled.span.withConfig({
  displayName: "Checkbox__CheckboxIndicator",
  componentId: "lztpq3-4"
})(({
  $checked,
  theme: _theme
}) => {
  const theme = _theme;
  return css(["transition:all 150ms ease-out 0s;flex-shrink:0;background:", ";color:", ";height:1.25em;width:1.25em;left:", ";position:relative;border:", " solid ", ";border-radius:", ";margin-top:", ";&:hover{background:", ";}"], theme.color['fill-surface-default'], theme.color['border-core-default'], theme.space['50'], theme.borderWidth['200'], $checked ? theme.color['fill-info-default'] : theme.color['border-core-default'], theme.borderRadius['100'], theme.space['100'], $checked ? theme.color['fill-surface-default'] : theme.color['fill-tertiary-default']);
});
const CheckboxCheck = styled.span.withConfig({
  displayName: "Checkbox__CheckboxCheck",
  componentId: "lztpq3-5"
})(({
  $checked,
  theme: _theme
}) => {
  const theme = _theme;
  return css(["align-items:center;display:flex;justify-content:center;inset:0;opacity:", ";position:absolute;svg{fill:", ";width:94%;}"], $checked ? '1' : '0', theme.color['fill-info-default']);
});
const CheckboxText = styled.span.withConfig({
  displayName: "Checkbox__CheckboxText",
  componentId: "lztpq3-6"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["position:relative;max-width:100%;padding-left:", ";", " display:inline-block;"], theme.space['300'], theme.typography['body-100']);
});
export const Checkbox = ({
  id,
  checked,
  onChange,
  children
}) => {
  return /*#__PURE__*/_jsx(CheckboxContainer, {
    children: /*#__PURE__*/_jsx(CheckboxLabel, {
      htmlFor: id,
      children: /*#__PURE__*/_jsxs(CheckboxWrapper, {
        children: [/*#__PURE__*/_jsxs(CheckboxIndicator, {
          $checked: checked,
          children: [/*#__PURE__*/_jsx(HiddenInput, {
            type: "checkbox",
            checked: checked,
            id: id,
            onChange: onChange
          }), /*#__PURE__*/_jsx(CheckboxCheck, {
            $checked: checked,
            children: checked && /*#__PURE__*/_jsx(CheckIcon, {})
          })]
        }), /*#__PURE__*/_jsx(CheckboxText, {
          children: children
        })]
      })
    })
  });
};